import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import EntryLines from "./components/EntryLines/EntryLines";

const MyLocatorEntry = () => {
  const theme = useTheme();
  const { t } = useTranslation(["d2d"]);
  const [showSuccessConfirmation, setShowSuccessConfirmation] = useState(false);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          component="h1"
          data-fuel-size="3xl"
          color={theme.tokens.FuelColorTextPrimary}
          fontWeight={theme.tokens.FuelFontWeightRegular}
          data-testid="my-locator-entry-header"
        >
          {t("d2d:myLocatorEntry.header.title")}
        </Typography>
      </Box>

      {!showSuccessConfirmation && (
        <Box
          sx={{
            marginTop: theme.tokens.FuelSpacing6,
            marginBottom: theme.tokens.FuelSpacing4,
          }}
        >
          <Typography
            data-testid="my-locator-entry-subheader"
            sx={{
              fontWeight: theme.tokens.FuelFontWeightSemibold,
              fontSize: theme.tokens.FuelFontSizeHeading4,
              color: theme.tokens.FuelColorTextPrimary,
            }}
          >
            {t("d2d:myLocatorEntry.subheader.enterLines")}
          </Typography>
        </Box>
      )}

      {}
      <EntryLines onSuccessConfirmation={setShowSuccessConfirmation} />
    </Box>
  );
};

export default MyLocatorEntry;
